import { useEffect, useCallback } from 'react';
import { useCurrentProjectId } from '@adsk/alloy-provider';
import { useDataApi } from '@adsk/alloy-helpers';
import { buildCreateProjectCompanyRequest } from '../utils';
import { ACTIONS } from '../state/actions';

const useCreateProjectCompany = ({
  createProjectUsersRequest,
  createProjectUsersRef,
  dispatch,
}) => {
  const projectId = useCurrentProjectId();
  const {
    data: createProjectCompanyData,
    error: createProjectCompanyError,
    doFetch: doCreateProjectCompanyFetch,
  } = useDataApi();

  const createProjectCompanyRequest = useCallback(
    (companyId) => {
      const companyData = {
        companyId,
      };
      doCreateProjectCompanyFetch(
        ...buildCreateProjectCompanyRequest(projectId, companyData)
      );
    },
    [doCreateProjectCompanyFetch, projectId]
  );

  // Handle create project company error
  useEffect(() => {
    if (!createProjectCompanyError) return;

    dispatch({
      type: ACTIONS.SET_SHOW_COMPANY_CREATE_ERROR,
      payload: true,
    });
    dispatch({
      type: ACTIONS.SET_IS_SAVING,
      payload: false,
    });
  }, [createProjectCompanyError, dispatch]);

  // Handle create project company success
  useEffect(() => {
    if (!createProjectCompanyData) return;

    dispatch({
      type: ACTIONS.SET_SHOW_COMPANY_CREATE_ERROR,
      payload: false,
    });
    dispatch({
      type: ACTIONS.ADD_NEWLY_CREATED_PROJECT_COMPANIES,
      payload: createProjectCompanyData,
    });
    createProjectUsersRequest(createProjectUsersRef.current);
  }, [
    createProjectCompanyData,
    createProjectUsersRef,
    createProjectUsersRequest,
    dispatch,
  ]);

  return {
    createProjectCompanyRequest,
  };
};

export default useCreateProjectCompany;
